export default __webpack_public_path__ + "static/media/Flag_of_Chile.32771584.svg";